module.exports = __webpack_public_path__ + "img/image30.71b4a6fb.png";